// videocards strings (es). Machine-drafted — review with a native speaker before launch.
const videocards = {
	videocards: {
		// ===== List page (index.tsx) =====
		helmetList: 'Tarjetas de video | CardClan',
		helmetDetails: 'Detalles de la tarjeta de video | CardClan',
		backToVideoCards: 'Volver a las tarjetas de video',
		title: 'Tarjetas de video',
		subtitle: 'Crea y gestiona tarjetas de felicitación en video',
		createVideoCard: 'Crear tarjeta de video',

		// Upgraded success banner
		bannerStackAdded: 'paquete añadido',
		bannerActivated: 'activado',
		upgradedBanner: '¡Oferta de por vida %{state}! Ahora tienes %{cards} tarjetas de video y %{minutes} minutos de renderizado al mes.',

		// Workspace disabled
		workspaceDisabledAlert: 'Las tarjetas de video están deshabilitadas para este espacio de trabajo. Contacta al administrador de tu espacio de trabajo.',
		workspaceDisabledBanner: 'Las tarjetas de video están deshabilitadas para este espacio de trabajo. Contacta al administrador de tu espacio de trabajo para habilitarlas.',

		// Get Started modal
		getStartedTitle: 'Comenzar',
		getStartedSubtitle: 'Configura tu tablero de tarjeta de video.',
		occasionLabel: 'Ocasión',
		occasionPlaceholder: 'Escribe o selecciona una ocasión...',
		loading: 'Cargando...',
		noMatchEnter: 'Sin coincidencias — pulsa Intro para usar "%{input}"',
		noCategories: 'No se encontraron categorías',
		recipientFirstName: 'Nombre del destinatario',
		firstNamePlaceholder: 'p. ej. Sara',
		lastName: 'Apellido',
		lastNamePlaceholder: 'Opcional',
		boardTitle: 'Título del tablero',
		boardTitlePlaceholder: 'Generado automáticamente a partir de la ocasión y el nombre',
		themePreview: 'Tema: %{occasion} — %{font}',
		cancel: 'Cancelar',
		creating: 'Creando...',
		createBoard: 'Crear tablero',

		// Auto-generated titles / fallbacks
		autoTitleHappyOccasionName: '¡Feliz %{occasion} %{name}!',
		autoTitleHappyOccasion: '¡Feliz %{occasion}!',
		autoTitleForName: 'Para %{name}',
		untitledVideoCard: 'Tarjeta de video sin título',

		// ===== Cards list (VideoCardsList.tsx) =====
		deleteConfirmTitle: '¿Eliminar tarjeta de video?',
		deleteConfirmText: 'Esto eliminará permanentemente esta tarjeta de video y todos sus envíos.',
		delete: 'Eliminar',
		noVideoCardsYet: 'Aún no hay tarjetas de video',
		createFirstVideoCard: 'Crea tu primera tarjeta de video para comenzar',
		videoCardBadge: 'Tarjeta de video',
		copied: '¡Copiado!',
		copyInviteLink: 'Copiar enlace de invitación',
		due: 'Vence: %{date}',

		// ===== Usage bar (VideoCardUsageBar.tsx) =====
		progressVideoCards: 'Tarjetas de video',
		progressRenderMinutes: 'Minutos de renderizado',
		tierFree: 'Gratis',
		tierLtd: 'Oferta de por vida',
		upgrade: 'Mejorar',
		stackMore: 'Añadir paquetes',

		// ===== Detail (VideoCardDetail.tsx) =====
		detailHelmetFallback: 'Tarjeta de video',
		statusSent: 'Enviada',
		statusProcessing: 'Procesando',
		statusScheduled: 'Programada',
		statusDraft: 'Borrador',
		tileSingular: 'mosaico',
		tilePlural: 'mosaicos',
		submissionSingular: 'envío',
		submissionPlural: 'envíos',
		editBoard: 'Editar tablero',
		deliveryModeVideo: 'Video',
		deliveryModeBoard: 'Tablero',
		preview: 'Vista previa de %{mode}',
		sentNoEdit: 'Esta tarjeta ha sido enviada y ya no se puede editar.',
		scheduledForPrefix: 'Programada para',
		futureDate: 'una fecha futura',
		atLabel: 'a las',
		cancelSchedule: 'Cancelar programación',

		// Tabs
		tabContent: 'Contenido y renderizado',
		tabSettings: 'Ajustes',
		tabDelivery: 'Entrega',

		// Content & render
		latestRenderedVideo: 'Último video renderizado',
		reRender: 'Volver a renderizar',
		downloadMp4: 'Descargar MP4',
		renderingFailed: 'Falló el renderizado. Inténtalo de nuevo.',
		renderVideo: 'Renderizar video',
		boardTilesHeading: 'Mosaicos del tablero (%{count})',
		tileBreakdown: '%{videos} videos, %{texts} textos, %{images} imágenes, %{gifs} GIF.',
		dragToReorderTiles: ' Arrastra para reordenar.',
		noBoardTiles: 'Aún no hay mosaicos en el tablero. Abre el editor o comparte el enlace de invitación.',
		videoBadge: 'Video',
		creator: 'Creador',
		videoSubmissionsHeading: 'Envíos de video (%{count})',
		dragReorderRenderSeq: 'Arrastra para reordenar. El orden determina la secuencia de renderizado.',

		// Render steps & errors
		stepExporting: 'Exportando capturas de página...',
		stepStarting: 'Iniciando renderizado...',
		stepQueued: 'En cola...',
		stepProcessing: 'Procesando... %{progress}%',
		errRenderingFailed: 'Falló el renderizado',
		errLostConnection: 'Se perdió la conexión con el progreso del renderizado',
		errTimeout: 'El renderizado agotó el tiempo después de 10 minutos',
		errRenderLimit: 'Límite de renderizado alcanzado. Mejora tu plan para obtener más minutos de renderizado.',
		errFailedStart: 'No se pudo iniciar el renderizado',

		// Save / status messages
		saved: '¡Guardado!',
		failedToSave: 'No se pudo guardar',
		scheduleCancelled: 'Programación cancelada',
		selectFutureDate: 'Selecciona una fecha y hora futuras',
		enterRecipientEmail: 'Introduce un correo del destinatario',
		scheduledMsg: '¡Programada!',

		// Settings tab
		contributionSettings: 'Ajustes de contribución',
		submissionDeadline: 'Fecha límite de envío',
		submissionDeadlineHint: 'Después de esta fecha, los colaboradores ya no podrán añadir contenido',
		maxClipDuration: 'Duración máxima del clip',
		maxClipDurationHint: 'Duración máxima del clip de video de cada colaborador',
		inviteMessage: 'Mensaje de invitación',
		inviteMessageHint: 'Mensaje personalizado que se muestra a los colaboradores en la página del tablero',
		inviteMessagePlaceholder: 'p. ej. ¡Graba un mensaje de cumpleaños para Sara!',
		deliveryFormat: 'Formato de entrega',
		deliveryFormatHint: '¿Cómo debe ver el destinatario esta tarjeta?',
		interactiveBoard: 'Tablero interactivo',
		interactiveBoardHint: 'El destinatario ve el tablero de mosaicos en vivo con efectos',
		renderedVideo: 'Video renderizado',
		renderedVideoHint: 'El destinatario recibe una compilación de video MP4',
		saving: 'Guardando...',
		saveSettings: 'Guardar ajustes',

		// Delivery tab
		cardSent: 'Tarjeta enviada',
		cardDeliveredTo: 'Esta tarjeta se ha entregado a %{recipient}.',
		theRecipient: 'el destinatario',
		senderEmail: 'Correo del remitente',
		sendFrom: 'Enviar desde',
		defaultCardClan: 'Predeterminado (CardClan)',
		senderEmailHint: 'Elige desde qué dirección de correo se enviará la tarjeta.',
		recipient: 'Destinatario',
		emailLabel: 'Correo electrónico',
		nameLabel: 'Nombre',
		recipientNamePlaceholder: 'Nombre del destinatario',
		schedule: 'Programación',
		sendDateTime: 'Fecha y hora de envío',
		sendDateTimeHint: 'Elige cuándo entregar la tarjeta. Déjalo vacío para enviarla manualmente.',
		autoRenderSend: 'Renderizar y enviar automáticamente a la hora programada',
		autoRenderSendHint: 'El video se renderizará y enviará por correo automáticamente cuando llegue el momento.',
		autoRenderSendTag: '(renderizar y enviar automáticamente)',
		shareLinks: 'Enlaces para compartir',
		inviteContributors: 'Invitar colaboradores',
		viewCardLabel: 'Ver tarjeta',
		copy: 'Copiar',
		scheduling: 'Programando...',
		scheduleSend: 'Programar envío',
		save: 'Guardar',
		sending: 'Enviando...',
		sendNow: 'Enviar ahora',
		sentSuccessfully: '¡Enviada con éxito!',
		failedToSend: 'No se pudo enviar. Inténtalo de nuevo.',

		// ===== Upgrade (VideoCardsUpgrade.tsx) =====
		upgradeHelmet: 'Mejorar tarjetas de video | CardClan',
		limitedTimeOffer: 'Oferta por tiempo limitado',
		upgradeIntro: 'Lleva tus celebraciones al siguiente nivel con tarjetas de video renderizadas. Debido a los costos de cómputo, el renderizado de video tiene límites de uso.',
		planFree: 'Gratis',
		foreverFree: 'Gratis para siempre',
		free2Cards: '2 tarjetas de video / mes',
		board10Items: '10 elementos del tablero / tarjeta',
		free20Min: '20 minutos renderizados / mes',
		currentPlan: 'Plan actual',
		freeTier: 'Nivel gratuito',
		lifetimeDeal: 'Oferta de por vida',
		perStack: '/ paquete',
		oneTimePayment: 'Pago único, acumula hasta %{max}x',
		currentPlanBadge: 'PLAN ACTUAL',
		bestValue: 'MEJOR VALOR',
		stackSingular: 'paquete',
		stackPlural: 'paquetes',
		yourCurrentPlan: 'Tu plan actual (%{count}x %{stacks})',
		planLimits: '%{cards} tarjetas de video / mes · %{minutes} min de renderizado / mes',
		ltdCardsPerStack: 'tarjetas de video / mes por paquete',
		ltdMinutesPerStack: 'minutos renderizados / mes por paquete',
		benefitNoFees: 'Sin cuotas recurrentes',
		benefitLifetime: 'Acceso de por vida',
		benefitPriority: 'Renderizado prioritario',
		benefitEarly: 'Precio para primeros usuarios',
		addStacksLabel: 'Añadir paquetes:',
		stacksLabel: 'Paquetes:',
		maxMore: '(máx. %{count} más)',
		afterPurchase: 'Después de la compra tendrás:',
		processing: 'Procesando...',
		addStacksBtnSingular: 'Añadir %{count} paquete',
		addStacksBtnPlural: 'Añadir %{count} paquetes',
		getStacksBtnSingular: 'Obtener %{count} paquete',
		getStacksBtnPlural: 'Obtener %{count} paquetes',
		maxStacksReached: 'Máximo de paquetes alcanzado (%{count}/%{max})',
	},
};
export default videocards;
